import { useId } from 'react';

// Figma "Match preparation" — the vector flexed arm, colors baked in by design.
const ARM =
  'M5.66775 6.1543H4.78292L2.76062 12.188C1.82523 15.3734 3.51516 17.5644 6.1148 17.5644H13.0329C15.505 17.5329 17.4993 15.5187 17.4993 13.0391C17.4993 10.5399 15.4733 8.51384 12.9741 8.51384C11.0106 8.51384 9.33921 9.76432 8.71283 11.5123C8.69455 11.5633 8.64657 11.5981 8.59239 11.5981C8.54546 11.5981 8.50241 11.572 8.48066 11.5305L5.66775 6.1543Z';
const FOLD =
  'M4.63965 17.2958C5.08276 17.4711 5.57941 17.5639 6.11461 17.5639H13.0327L8.7311 11.6638C8.7008 11.6222 8.65246 11.5977 8.60103 11.5977C8.54775 11.5977 8.49792 11.624 8.46795 11.6681L4.63965 17.2958Z';
const CUFF =
  'M5.31857 4.64168L4.7666 6.20277L5.03549 6.72177C5.22198 7.09205 5.60119 7.32566 6.01578 7.32566H8.6804C9.2285 7.32566 9.72206 6.99386 9.92896 6.48631L9.97594 6.37107C10.3604 5.42804 9.92744 4.35008 8.99755 3.93489L8.04047 3.52932C6.86912 3.09533 5.73099 3.55484 5.31857 4.64168Z';
const CUFF_SHADE =
  'M5.17729 5.04144L4.7666 6.20295L5.03549 6.72196C5.22198 7.09224 5.60119 7.32584 6.01578 7.32584H6.99974C7.11772 6.9926 7.61912 5.86789 7.61912 5.52237C7.03345 4.70074 5.87896 4.57847 5.17729 5.04144Z';

export default function GameTypeMatchPrep({ className }: { className?: string }) {
  const id = `game-type-match-prep-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={ARM} fill="#FFB336" />
      <path d={ARM} fill={`url(#${id}-0)`} />
      <path d={ARM} fill={`url(#${id}-1)`} />
      <path d={ARM} fill={`url(#${id}-2)`} />
      <path d={ARM} fill={`url(#${id}-3)`} />
      <path d={ARM} fill={`url(#${id}-4)`} />
      <path d={ARM} fill={`url(#${id}-5)`} />
      <circle cx="12.9745" cy="13.0389" r="4.52526" fill={`url(#${id}-6)`} />
      <circle cx="12.9745" cy="13.0389" r="4.52526" fill={`url(#${id}-7)`} />
      <circle cx="12.9745" cy="13.0389" r="4.52526" fill={`url(#${id}-8)`} />
      <path d={FOLD} fill={`url(#${id}-9)`} />
      <path d={FOLD} fill={`url(#${id}-10)`} />
      <path d={FOLD} fill={`url(#${id}-11)`} />
      <path d={CUFF} fill={`url(#${id}-12)`} />
      <path d={CUFF} fill={`url(#${id}-13)`} />
      <path d={CUFF} fill={`url(#${id}-14)`} />
      <path d={CUFF} fill={`url(#${id}-15)`} />
      <path d={CUFF} fill={`url(#${id}-16)`} />
      <path d={CUFF_SHADE} fill={`url(#${id}-17)`} />
      <path d={CUFF_SHADE} fill={`url(#${id}-18)`} />
      <path d={CUFF_SHADE} fill={`url(#${id}-19)`} />
      <path d={CUFF_SHADE} fill={`url(#${id}-20)`} />
      <path d={CUFF_SHADE} fill={`url(#${id}-21)`} />
      <rect
        x="4.75879"
        y="5.64453"
        width="4.80757"
        height="2.19522"
        rx="1.09761"
        fill={`url(#${id}-22)`}
      />
      <rect
        x="4.75879"
        y="5.64453"
        width="4.80757"
        height="2.19522"
        rx="1.09761"
        fill={`url(#${id}-23)`}
      />
      <rect
        x="4.75879"
        y="5.64453"
        width="4.80757"
        height="2.19522"
        rx="1.09761"
        fill={`url(#${id}-24)`}
      />
      <rect
        x="4.75879"
        y="5.64453"
        width="4.80757"
        height="2.19522"
        rx="1.09761"
        fill={`url(#${id}-25)`}
      />
      <rect
        x="4.75879"
        y="5.64453"
        width="4.80757"
        height="2.19522"
        rx="1.09761"
        fill={`url(#${id}-26)`}
      />
      <defs>
        <radialGradient
          id={`${id}-0`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.55054 11.0756) rotate(106.684) scale(11.8587 7.91471)"
        >
          <stop stopColor="#FFDC45" />
          <stop offset="0.485788" stopColor="#FFB425" />
          <stop offset="0.694142" stopColor="#E4A449" />
        </radialGradient>
        <radialGradient
          id={`${id}-1`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.83144 11.2779) rotate(90) scale(6.28649 2.22471)"
        >
          <stop stopColor="#FFE85A" />
          <stop offset="1" stopColor="#FFE85A" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-2`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.92132 11.2105) rotate(74.1481) scale(2.83826 1.249)"
        >
          <stop offset="0.265585" stopColor="#F8AE27" />
          <stop offset="1" stopColor="#F8AE27" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-3`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.69661 7.11497) rotate(114.6) scale(1.53851 3.06201)"
        >
          <stop offset="0.577703" stopColor="#EA9211" />
          <stop offset="1" stopColor="#FFB122" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-4`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.26964 13.1487) rotate(90) scale(2.12359 0.557007)"
        >
          <stop stopColor="#FFE262" />
          <stop offset="1" stopColor="#FFE262" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-5`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.87638 0.0869046) rotate(98.7091) scale(19.8126 11.4717)"
        >
          <stop offset="0.720455" stopColor="#FEA949" stopOpacity="0" />
          <stop offset="0.87883" stopColor="#D98171" />
        </radialGradient>
        <radialGradient
          id={`${id}-6`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.0559 11.1092) rotate(142.37) scale(7.61862)"
        >
          <stop offset="0.0675345" stopColor="#FFEE66" />
          <stop offset="0.564471" stopColor="#FFB72B" />
          <stop offset="0.790419" stopColor="#F9A417" />
        </radialGradient>
        <radialGradient
          id={`${id}-7`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.98854 12.7946) rotate(140.194) scale(1.5796 6.86542)"
        >
          <stop stopColor="#FCA32D" />
          <stop offset="1" stopColor="#FCA32D" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-8`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5054 2.31145) rotate(90) scale(16.9213 20.1572)"
        >
          <stop offset="0.775168" stopColor="#FEA949" stopOpacity="0" />
          <stop offset="0.882559" stopColor="#D98171" />
        </radialGradient>
        <linearGradient
          id={`${id}-9`}
          x1="8.83617"
          y1="11.5977"
          x2="8.83617"
          y2="17.5639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE28" />
          <stop offset="0.30226" stopColor="#FFC724" />
          <stop offset="0.646892" stopColor="#FFAE4E" />
          <stop offset="0.810734" stopColor="#F0934C" />
          <stop offset="1" stopColor="#D97975" />
        </linearGradient>
        <radialGradient
          id={`${id}-10`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.1351 12.4741) rotate(144.941) scale(1.17362 4.51366)"
        >
          <stop offset="0.555041" stopColor="#FCA32D" />
          <stop offset="1" stopColor="#FCA32D" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-11`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.37103 12.3392) rotate(29.2914) scale(0.792311 3.04719)"
        >
          <stop offset="0.555041" stopColor="#FFDE4D" />
          <stop offset="1" stopColor="#FFDE4D" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-12`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.65704 6.03642) rotate(18.1219) scale(2.92603 2.64524)"
        >
          <stop offset="0.113168" stopColor="#F69F02" />
          <stop offset="0.470489" stopColor="#FFC040" />
          <stop offset="0.708968" stopColor="#FFDA43" />
          <stop offset="1" stopColor="#FFD453" />
        </radialGradient>
        <radialGradient
          id={`${id}-13`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.57838 5.04204) rotate(-7.38604) scale(0.917724 1.73637)"
        >
          <stop stopColor="#FFEE67" />
          <stop offset="0.868945" stopColor="#FFEE67" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-14`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.37613 6.47462) rotate(24.271) scale(10.1684 14.7479)"
        >
          <stop offset="0.286903" stopColor="#F2AC31" stopOpacity="0" />
          <stop offset="0.408072" stopColor="#F2AC31" />
        </radialGradient>
        <radialGradient
          id={`${id}-15`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.65704 5.34646) rotate(99.7446) scale(0.597452 1.15501)"
        >
          <stop offset="0.168529" stopColor="#FFA905" />
          <stop offset="1" stopColor="#FEA803" stopOpacity="0" />
          <stop offset="1" stopColor="#FFA905" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-16`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.75816 5.65721) rotate(106.821) scale(0.378556 0.731832)"
        >
          <stop offset="0.168529" stopColor="#A4570A" />
          <stop offset="1" stopColor="#FFA905" stopOpacity="0" />
          <stop offset="1" stopColor="#E38D0E" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={`${id}-17`}
          x1="4.7666"
          y1="6.05539"
          x2="7.61912"
          y2="6.62631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6A94B" />
          <stop offset="0.237875" stopColor="#F7AD25" />
          <stop offset="0.670756" stopColor="#FFD55C" />
          <stop offset="1" stopColor="#F8A707" />
        </linearGradient>
        <radialGradient
          id={`${id}-18`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.345504 0.0674155 -0.170786 0.555673 7.69917 5.5898)"
        >
          <stop offset="0.168529" stopColor="#A4570A" />
          <stop offset="1" stopColor="#FFA905" stopOpacity="0" />
          <stop offset="1" stopColor="#E38D0E" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-19`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.35579 1.22974 -0.290055 1.17449 5.29529 5.73793)"
        >
          <stop stopColor="#F3AC30" />
          <stop offset="0.958333" stopColor="#F3AC30" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-20`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.04473 5.67483) rotate(63.6216) scale(1.01017)"
        >
          <stop stopColor="#F3AC30" />
          <stop offset="0.958333" stopColor="#F3AC30" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-21`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.82051 6.33805) rotate(48.0128) scale(0.434471 0.485557)"
        >
          <stop stopColor="#ED9C21" />
          <stop offset="1" stopColor="#ED9C21" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-22`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.3599 6.08694) rotate(180) scale(12.1685 4.13128)"
        >
          <stop offset="0.168975" stopColor="#FFBB27" />
          <stop offset="0.401662" stopColor="#FEA538" />
          <stop offset="0.509695" stopColor="#F49A25" />
        </radialGradient>
        <radialGradient
          id={`${id}-23`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.74192 6.12065) rotate(90) scale(0.943817 11.7303)"
        >
          <stop stopColor="#FFBD26" />
          <stop offset="1" stopColor="#FFBD26" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-24`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.05653 6.45773) rotate(126.327) scale(1.42253 1.73926)"
        >
          <stop stopColor="#FFE866" />
          <stop offset="1" stopColor="#FFCD2F" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-25`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.50223 5.9679) rotate(54.1909) scale(1.17763 1.78074)"
        >
          <stop offset="0.417703" stopColor="#F3AC30" />
          <stop offset="0.958333" stopColor="#F3AC30" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-26`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.3541 6.16355) rotate(-2.89476) scale(10.2773 6.44682)"
        >
          <stop offset="0.507261" stopColor="#F5CC90" stopOpacity="0" />
          <stop offset="0.573655" stopColor="#E6BD82" />
        </radialGradient>
      </defs>
    </svg>
  );
}
